<template>
  <div class="packages">
    <div class="container">
      <div class="heading">
        <h2>THE TYPE OF PLANS ONE LOVES</h2>
        <p>
          Choose a plan that is best suits your publishing journey.
        </p>
      </div>
      <div class="tags">
        <div v-if="false" class="wrapper-tags">
          <div
            class="tag"
            v-for="(tag, i) in sortTags"
            :key="i"
            @click="toogleSort(tag)"
            :class="{ active: activeSortTags.indexOf(tag) >= 0 }"
          >
            {{ tag }}
          </div>
        </div>
        <div class="subscription">
          <span @click="toggleDuration('monthly')">Monthly</span>
          <div
            class="toggler"
            @click="toggleDuration(undefined)"
            :class="[yearly ? 'bg' : '']"
          >
            <div class="slider" :class="[yearly ? 'btns' : '']"></div>
          </div>
          <span @click="toggleDuration('yearly')">Annually</span>
        </div>
      </div>
      <div class="pricing-cards">
        <div class="row">
          <!-- <Card v-for="(card, i) in mainCards" :key="i" :card="card"></Card> -->
          <div
            class="col-md-6 col-lg-4"
            v-for="(card, i) in mainCards"
            :key="i"
          >
            <div class="price-card d-flex flex-column align-items-center">
              <h2>{{ card.status }}</h2>
              <h1 class="price">
                {{ yearly ? card.yearlyPrice : card.monthlyPrice }}
              </h1>
              <h3 class="month">{{ yearly ? card.year : card.month }}</h3>
              <div class="features">
                <p v-for="(feature, i) in card.features" :key="i">
                  {{ feature }}
                </p>
              </div>
              <b-button
                variant="primary btn-round-fill no-shadow"
                :class="{ activee: card.upgrade }"
                >{{ card.upgrade ? "Start Free Trial" : "Start" }}</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/assets/_config.json";

export default {
  name: "Packages",
  data() {
    return {
      mainCards: [
        {
          status: "FREE",
          monthlyPrice: "$0",
          yearlyPrice: "$0",
          month: "PER MONTH",
          year: "PER YEAR",
          button: "Current Subscription",
          upgrade: false,
          features: [
            "Always Free Forever",
            "Add Up To 3 Family Members",
            "Access to over 50+ Apps",
            "Basic Tracking",
            "Unlimited Blog Reads",
            "A Supportive Community"
          ]
        },
        {
          status: "CLOSE-KNIT",
          monthlyPrice: "$9",
          yearlyPrice: "$100",
          month: "PER MONTH",
          year: "PER YEAR",
          button: "Upgrade",
          upgrade: true,
          features: [
            "Everything in Free Level Plus (+)",
            "Add Unlimited Family Members",
            "Unlock Communication Apps",
            "MyChart Data",
            "Diagnostic Level Tracking",
            "App Insights",
            "Priority E-mail Support"
          ]
        },
        {
          status: "SOLID",
          monthlyPrice: "$20",
          yearlyPrice: "$175",
          month: "PER MONTH",
          year: "PER YEAR",
          button: "Upgrade",
          upgrade: true,

          features: [
            "Free Access to Subscription MyApps",
            "Everything in Close-Knit Level Plus",
            "Unlock Management Apps",
            "Detailed Tracking and Charts",
            "Phone Support",
            "24/7 Access to Health Consultant"
          ]
        }
      ],
      sortTags: ["Member", "Guide", "Company"],
      activeSortTags: ["Member"],
      priceCards: [
        [
          {
            status: "FREE",
            monthlyPrice: "$0",
            yearlyPrice: "$10",
            month: "PER MONTH",
            year: "PER YEAR",
            button: "Current Subcription",
            upgrade: false,
            features: [
              "Advantages features",
              "Advantages features",
              "Advantages features",
              "Advantages features"
            ]
          },
          {
            status: "STARTER",
            monthlyPrice: "$1",
            yearlyPrice: "$10",
            month: "PER MONTH",
            year: "PER YEAR",
            button: "Upgrade",
            upgrade: true,
            features: [
              "Advantages features",
              "Advantages features",
              "Advantages features",
              "Advantages features"
            ]
          },
          {
            status: "PREMIUM",
            monthlyPrice: "$3",
            yearlyPrice: "$10",
            month: "PER MONTH",
            year: "PER YEAR",
            button: "Upgrade",
            upgrade: true,

            features: [
              "Advantages features",
              "Advantages features",
              "Advantages features",
              "Advantages features"
            ]
          }
        ],
        [
          {
            status: "FREE",
            monthlyPrice: "$4",
            yearlyPrice: "$10",
            month: "PER MONTH",
            year: "PER YEAR",
            button: "Current Subcription",
            upgrade: false,
            features: [
              "Guide features",
              "Guide features",
              "Guide features",
              "Guide features"
            ]
          },
          {
            status: "STARTER",
            monthlyPrice: "$8",
            yearlyPrice: "$10",
            month: "PER MONTH",
            year: "PER YEAR",
            button: "Upgrade",
            upgrade: true,
            features: [
              "Guide features",
              "Guide features",
              "Guide features",
              "Guide features"
            ]
          },
          {
            status: "PREMIUM",
            monthlyPrice: "$16",
            yearlyPrice: "$20",
            month: "PER MONTH",
            year: "PER YEAR",
            button: "Upgrade",
            upgrade: true,

            features: [
              "Guide features",
              "Guide features",
              "Guide features",
              "Guide features"
            ]
          }
        ],
        [
          {
            status: "FREE",
            monthlyPrice: "$0",
            yearlyPrice: "$10",
            month: "PER MONTH",
            year: "PER YEAR",
            button: "Current Subcription",
            upgrade: false,
            features: [
              "Company features",
              "Company features",
              "Company features",
              "Company features"
            ]
          },
          {
            status: "STARTER",
            monthlyPrice: "$18",
            yearlyPrice: "$28",
            month: "PER MONTH",
            year: "PER YEAR",
            button: "Upgrade",
            upgrade: true,
            features: [
              "Company features",
              "Company features",
              "Company features",
              "Company features"
            ]
          },
          {
            status: "PREMIUM",
            monthlyPrice: "$38",
            yearlyPrice: "$48",
            month: "PER MONTH",
            year: "PER YEAR",
            button: "Upgrade",
            upgrade: true,

            features: [
              "Company features",
              "Company features",
              "Company features",
              "Company features"
            ]
          }
        ]
      ],
      yearly: false,
      config
    };
  },
  methods: {
    toggleDuration(method) {
      if (!method) {
        this.yearly = !this.yearly;
      } else {
        this.yearly = method !== "monthly";
      }
    },
    toogleSort(tag) {
      this.activeSortTags = [];
      this.activeSortTags.push(tag);
      if (tag == "Member") {
        this.mainCards = this.priceCards[0];
      } else if (tag == "Guide") {
        this.mainCards = this.priceCards[1];
      } else if (tag == "Company") {
        this.mainCards = this.priceCards[2];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.packages {
  padding-top: 38px;
  padding-bottom: 48px;
  .heading {
    margin-bottom: 32px;
    h2 {
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 44px;
      color: #474d52;
      margin-bottom: 5px;
      text-transform: uppercase;
      text-align: center;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
      text-align: center;
    }
  }
  .tags {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .wrapper-tags {
      margin-bottom: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      .tag {
        margin: 0 8px;
        height: 46px;
        padding: 0 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #5b606c;
        background: #ffffff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 32px;
        cursor: pointer;
        transition: 0.2s ease;
        &:hover,
        &.active {
          background: rgba(85, 126, 251, 0.1);
          color: #557efb;
        }
      }
    }
  }
  .subscription {
    display: flex;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 70px;
    &.report {
      width: 230px;
      margin-top: 0 !important;
    }
    span {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #474d52;
      font-family: "Nunito", sans-serif;
      cursor: pointer;
    }
    .toggler {
      @media (max-width: 874px) {
        // margin-bottom: 10px;
        margin-left: 15px;
      }
      margin: 0 8px;
      cursor: pointer;
      position: relative;
      display: inline-block;
      width: 46.5px;
      height: 24px;
      background: #f3f6f9;
      border-radius: 18px;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
    .slider {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background: #b3c2cb;
      box-shadow: 0px 3px 9px #c4c4c4;

      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 50%;
    }
    .bg {
      background: rgba(85, 126, 251, 0.1);
    }
    .btns {
      left: 50%;
      background: #557efb;
      box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
    }
  }
  .pricing-cards {
    .price-card {
      font-family: "Nunito", sans-serif;
      filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
      background: #ffffff;
      border-radius: 8px;

      width: 100%;
      margin-bottom: 10px;

      @media (max-width: 767px) {
        margin-left: auto;
        margin-right: auto;
        max-width: 350px;
      }
      h2 {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.05em;
        margin-top: 32px;
        margin-bottom: 14px;

        color: #474d52;
      }
      .price {
        font-style: normal;
        font-weight: bold;
        font-size: 40px;
        display: flex;
        align-items: center;
        text-align: center;

        margin-bottom: 18px;
        color: #474d52;
      }
      .month {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;
        color: #474d52;
      }
      .features {
        margin-top: 32px;
        p {
          font-style: normal;
          font-weight: 600;
          font-size: 14px;

          display: flex;
          align-items: center;
          letter-spacing: 0.03em;

          /* Secondary */

          color: #8d99a0;
          margin-bottom: 16px;
        }
      }

      .btn-round-fill {
        max-width: 205px !important;
        width: 100%;
        height: 48px !important;
        font-family: "Nunito", sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        /* identical to box height */
        color: #fff;
        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
        border-radius: 100px !important;
        border: none;
        margin-bottom: 24px;
        margin-top: 32px !important;
        padding: 15px 10px !important;
        &.activee {
          background: rgba(85, 126, 251, 0.1) !important;
          color: #557efb;
          &:hover {
            background: #557efb !important;
            color: #fff;
          }
        }
      }
    }
  }
  .btn-round-fill {
    &:hover {
      &:before {
        content: none;
      }
      &:after {
        content: none;
      }
    }
    &:hover {
      background: #557efb !important;
      color: #fff;
    }
  }
}
</style>
